export default "/packs/images/physio~4cf9e0ce315f6a7775b029f3bc4f3506.jpg";